import Command from "./Command"
import { resolveTemplateStringAndLogErrors } from "./resolve-template-string"
import { isValidUri } from "../utils/uri"
import { ComponentNamespace, getPubsub } from "../redux/pubsub"

export function runStartRule(
  ruleTagOrUriTemplate: string,
  parametersJson: string | null | undefined,
  namespace: ComponentNamespace,
  additionalTemplateVariables?: Record<string, string>,
) {
  const dict = {
    ...(getPubsub(namespace) ?? {}),
    ...(additionalTemplateVariables ?? {}),
     
  }
    //console.log(dict)
   return new Promise((resolve, reject) => {
   
    const resolvedRule = resolveTemplateStringAndLogErrors(ruleTagOrUriTemplate, dict)
    const resolvedParameters = resolveTemplateStringAndLogErrors(parametersJson ?? "", dict)
   //console.log("promise",resolvedParameters,dict);
  
    

    if (isValidUri(resolvedRule)) {
      Command.ruleRule(resolvedRule, resolvedParameters, resolve, reject, { namespace })
    } else {
      Command.runRulesWithTag(resolvedRule, resolvedParameters, resolve, reject, { namespace })
    }
  })
}
